import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import Navbar from '../../Components/Navbar';
import photo1 from "../../assests/Services/serac.png"
import photo2 from "../../assests/Services/sercctv.png"
import photo3 from "../../assests/Services/sercons.png"
import photo4 from "../../assests/Services/serde.png"


import photo7 from "../../assests/Services/serpai.png"
import Footer from '../../Components/Footer';

import gifConstruction from "../../assests/Gif/build.gif";
import gifDemolition from "../../assests/Gif/de.gif";
import gifAC from "../../assests/Gif/ac.gif";
import gifPainting from "../../assests/Gif/pain.gif";
import gifElectrical from "../../assests/Gif/ele.gif";
import gifSecurity from "../../assests/Gif/security.gif";


const servicesData = [
    {
        icon: '🏗️', // You can use a static image for this as well
        title: 'CONSTRUCTION SERVICES',
        gif: gifConstruction,
        description: "We're building the future, one blueprint at a time. From initial structural work to the finishing touches, our team delivers with precision and care.",
        items: [
            'GENERAL CONSTRUCTION WORK',
            'RC AND STEEL STRUCTURE WORKS',
            'CONCRETE REPAIR & MAINTENANCE',
            'WATERPROOFING WORKS',
            'PU GROUTING',
            'CRACK INJECTION & REHABILITATION'
        ]
    },
    {
        icon: '💥',
        title: 'DEMOLITION SERVICES',
        gif: gifDemolition,
        description: "Clearing the path for what's next. Our controlled demolition services are safe, precise, and handled with the highest level of expertise.",
        items: [
            'GENERAL DEMOLITION WORKS',
            'DIAMOND STITCH CORING',
            'DIAMOND WALL & WIRE SAW CUTTING',
            'HYDRAULIC CRUSHER & BREAKER SERVICES',
            'HYDRO DEMOLITION / HYDRO CUTTING',
            'CONTROLLED DEMOLITION'
        ]
    },
    {
        icon: '❄️',
        title: 'AC SERVICES',
        gif: gifAC,
        description: "Feel the cool breeze. We handle everything from installation to maintenance, ensuring your space is always comfortable and clean.",
        items: [
            'AC INSTALLATION (ALL TYPES: SPLIT, DUCTED, PACKAGE UNITS)',
            'GENERAL AC SERVICING & CLEANING',
            'CHEMICAL CLEANING SERVICE',
            'NEW AC SYSTEM INSTALLATION & DUCTING WORKS',
            'AC REPAIR & MAINTENANCE'
        ]
    },
    {
        icon: '🖌️', // Icon representing finishing and detail work
        title: 'PAINTING & TILING SERVICES',
        gif: gifPainting,
        description: "We add the final, transformative touches to your space. Our experts specialize in bringing surfaces to life with skilled painting and precise tiling.",
        items: [
            'INTERIOR & EXTERIOR PAINTING',
            'TILES REPAIR & REPLACEMENT',
            'FLOOR & WALL TILING',
            'CUSTOMIZED PAINTING & TILING',
            'WATERPROOFING & EPOXY COATING',
            'GROUTING & RE-GROUTING',
            'DECORATIVE & TEXTURE PAINTING'
        ]
    },
    {
        icon: '⚡',
        title: 'ELECTRICAL SERVICES',
        gif: gifElectrical,
        description: "Powering your projects with safe and reliable electrical solutions. Our certified electricians ensure every connection is secure and efficient.",
        items: [
            'INTERNAL & EXTERNAL ELECTRICAL INSTALLATIONS',
            'SWITCHGEAR & PANEL INSTALLATION',
            'ELECTRICAL MAINTENANCE & TROUBLESHOOTING',
            'NEW WIRING AND REWIRING PROJECTS'
        ]
    },
    {
        icon: '🛡️',
        title: 'SECURITY SYSTEMS',
        gif: gifSecurity,
        description: "Your safety is our top priority. We install cutting-edge security systems, from smart cameras to automated gates, for complete peace of mind.",
        items: [
            'CCTV INSTALLATION (INDOOR & OUTDOOR)',
            'AI-BASED CCTV & SMART CAMERAS',
            'HIGH-RESOLUTION CAMERAS & NIGHT VISION SYSTEMS',
            'BARRIER SYSTEM INSTALLATION',
            'AUTOMATED GATES & ACCESS CONTROL SYSTEMS',
            'PRIVACY FENCING & MOTION DETECTION SYSTEM',
            'MAINTENANCE OF SECURITY SYSTEMS'
        ]
    },
];


const OurServices = () => {
    const images = [photo1, photo2, photo3, photo4, photo7];

    const [angle, setAngle] = useState(0);
    const carouselRef = useRef(null);

    useEffect(() => {
        const interval = setInterval(() => {
            setAngle(prev => prev - 72); // 360/5 images = 72 degrees
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <div className="our-services-container">
                <Navbar />
                <h1 className="our-services-main-title">Our Services</h1>
                <div className="carousel-container">
                    <div
                        className="carousel"
                        ref={carouselRef}
                        style={{ transform: `translateZ(-288px) rotateY(${angle}deg)` }}
                    >
                        {images.map((src, index) => (
                            <div className="carousel__face" key={index}>
                                <img src={src} alt={`Slide ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="our-services-list-wrapper">
                    {servicesData.map((service, index) => (
                        <div
                            key={index}
                            className={`our-services-item ${index % 2 === 0 ? 'even' : 'odd'}`}
                        >
                            <div className="our-services-header">
                                {/* <span className="our-services-icon">{service.icon}</span> */}
                                {service.gif?.trim() && (
                                    <img src={service.gif} alt={service.title} className="service-gif" width={100} />
                                )}

                                <h2 className="our-services-title">{service.title}</h2>
                                <p className="our-services-description">{service.description}</p>
                            </div>
                            <ul className="our-services-content">
                                {service.items.map((item, itemIndex) => (
                                    <li key={itemIndex}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

            </div>
            <Footer />
        </>
    );
};

export default OurServices;